const subscriptionState = [
	"ACTIVE",
	"PENDING",
	"EXPIRED",
	"CANCELLED",
	"ANONYMISED",
	"UNKNOWN",
	"FAILED",
] as const;
export type SubscriptionState = (typeof subscriptionState)[number];

export const parseSubscriptionState = (value: string): SubscriptionState => {
	if (subscriptionState.includes(value as SubscriptionState)) {
		return value as SubscriptionState;
	}

	throw new Error(`does not recognize SubscriptionState.type=${value}`);
};
